import React from 'react'

export default function Add (props) {
  const width = props.width || 16 // 图标的宽度
  const height = props.height || 16 // 图标的高度
  const circleBg = props.circleBg || 'none' // 圆的背景色
  const circleStroke = circleBg === 'none' ? '#bcbcbc' : circleBg // 圆的边框线颜色
  const lineStroke = circleBg === 'none' ? '#bcbcbc' : '#fff' // 中间的加号的线条颜色
  return (
    <svg version='1.1' id='图层_1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
      viewBox='0 0 1024 1024' width={width} height={height} xmlSpace='preserve'>
      <circle fill={circleBg} stroke={circleStroke} strokeWidth='64' cx='512' cy='512' r='440' />
      <line fill='none' stroke={lineStroke} strokeWidth='64' strokeMiterlimit='10' x1='256' y1='510' x2='768' y2='510' />
      <line fill='none' stroke={lineStroke} strokeWidth='64' strokeMiterlimit='10' x1='510' y1='256' x2='510' y2='768' />
    </svg>
  )
}
